import styled, { css } from "styled-components";

const DeliveryTimelineItemStyled = styled.div`
    display: flex;
    overflow: hidden;

    .timeline {
      
        position: relative;
        z-index:  2;
        padding-left: 5px;
        margin-top: 5px;
    
    }

    .dash {
        width: 2px;
        border-left: 2px dashed #CFD0CF;
        height: 100%;
        display: block;
        position: absolute;
        margin-left: 7px;
     }

     .circle {
    width: 16px;
    height: 16px;
    background: #CFD0CF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.circle::before {
    content: '';
    width: 26px;
    height: 26px;
    background: #F3F3F3;
    border-radius: 50%;
    position: absolute;
     top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1; /* Send the pseudo-element to the back */
}

.timelineInfoWrapper {
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-bottom: 15px;
 }

.title {
    color: #3D4543;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 24px;
 }

 .dateLocationWrapper {
    display: flex;
    flex-direction: column;
  }

 .statusDate {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 24px;
    color: #757575;
  }

  .statusLocation {
    
    display: flex;
    align-items: start;
    gap: 3px;
    & > p {
        font-size: 1.4rem;
    font-weight: 400;
    line-height: 24px;
    color: #757575;
    }

    & > svg {
        margin-top: 4px;
    }
  }

  ${props => {
        return (
            props.currentStatus &&
            css`

.circle {
    background: #00A76A;
}

.circle::before {
    background: #E2F8E8;
}
            `
        );
    }}

${props => {
        return (
            props.isLastItem &&
            css`

        .dash {
        border-left: 0px dashed #CFD0CF;
        }


            `
        );
    }}
`

export { DeliveryTimelineItemStyled };